<template>
    <div class="widget" v-bind:class="[{'loaded':loaded},className]">

        <header class="widget-header">
            <h2 class="widget-title">{{ title }}</h2>
            <h3 class="widget-title-period">
                Depuis le 01.01.2020 à aujourd'hui
            </h3>

            <div class="widget-actions-container">
            </div>

        </header>

        <div class="widget-preloader">
            <div class="pre-loader">
                <div class="box1"></div>
                <div class="box2"></div>
                <div class="box3"></div>
                <div class="box4"></div>
                <div class="box5"></div>
            </div>
        </div>

        <div class="widget-content">

            <div style="width: 100%;">
                <div style="display: flex;font-size: 10px;font-weight:400;padding: 0;align-items: center;width: 100%;border-bottom:1px solid #eee;text-transform: uppercase">
                    <div style="flex:1;padding: 10px;">Rapporteurs d'affaires</div>
                    <div style="width:120px;text-align:right;margin-right: 10px;padding: 10px;">Projection</div>
                    <div style="margin-left:auto;width:120px;text-align:right;padding: 10px;">Contrats payés</div>
                </div>

                <div v-for="item in stats" style="display: flex;font-size: 12px;align-items: center;width: 100%;border-bottom:1px solid #eee;height: auto;padding: 0;">
                    <div class="picture">
                        <figure>
                            <i class="icon icon-icon_person"></i>
                        </figure>
                    </div>
                    <div style="padding: 10px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;flex:1;">
                        <strong style="font-weight: 800;font-size: 1.1em; margin-bottom: 0.3em; display: block;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                            {{ item.name }}
                        </strong>
                        <p>Référence: {{ item.code }}</p>
                    </div>
                    <div style="width: 120px;text-align: right;padding: 10px;margin-right: 10px;">
                        <strong style="font-weight:800;font-size:1.2em;"><i>{{ currency }}</i> {{ (item.in_progress.total)|formatNumber }}</strong>
                        <p style="margin-top: 3px;"><i>{{ currency }}</i> {{ item.in_progress.total_capital|formatNumber }}</p>
                    </div>
                    <div style="width: 120px;text-align: right;padding: 10px;background: #f2f7e3;">
                        <strong style="font-weight:800;font-size:1.2em;color: green;"><i>{{ currency }}</i> {{ (item.completed.total)|formatNumber }}</strong>
                        <p style="margin-top: 3px;"><i>{{ currency }}</i> {{ item.completed.total_capital|formatNumber }}</p>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>
<script>

    import ProtractorService from './ProtractorService.js';
    import Bar from '../../../components/chart/Spline.vue'

    export default {
        name: 'Widget',
        components: {
            'chart' : Bar
        },
        props: ['title','period','className'],
        data () {
            return {
                currency: "CHF",
                periods: [
                    {id: 'last_7days', label: '7 derniers jours'},
                    {id: 'current_month', label: 'Ce mois'},
                    {id: 'last_month', label: 'Le mois dernier'},
                    {id: 'since_1_month', label: '30 derniers jours'},
                    {id: 'since_3_months', label: '90 derniers jours'},
                    {id: 'current_year', label: 'Cette année'},
                    {id: 'last_year', label: 'Depuis 12 mois'},
                    {id: 'all', label: 'Tout'},
                    {id: 'custom', label: 'Personnalisé'},
                ],
                loaded: false,
                stats: [],
                dateFilter: {
                    start_at: '',
                    end_at: '',
                },
                showAdvancedFilterVue: false,
                count: null,
                total: null,
                options: {
                    layout: {
                        padding: {
                            left: 0,
                            right: 10,
                            top: 0,
                            bottom: 0
                        }
                    },
                    scales: {
                        xAxes: [ {
                            categoryPercentage: 0.9,
                            barPercentage: 0.9,
                            stacked: false,
                            steppedLine: true,
                            gridLines: {
                                offsetGridLines: false,
                                display: false,
                                color: "#dddddd",
                                drawBorder: false
                            },
                            ticks: {
                                display: true,
                                fontColor: "#aaaaaa",
                                fontSize: 12,
                            },
                        }],
                        yAxes: [ {
                            stacked: false,
                            steppedLine: true,
                            gridLines: {
                                offsetGridLines: true,
                                display: true,
                                color: "#dddddd",
                                borderDashOffset: 1,
                                borderDash: [2,2],
                                drawBorder: false
                            },
                            ticks: {
                                fontColor: "#aaaaaa",
                                fontSize: 12,
                                display: true,
                                padding: 0
                                //stepSize: 1,
                                //suggestedMax: 0,
                                //suggestedMin: 0
                            }
                        }]
                    }
                }
            }
        },
        mounted: function(){

            this.period = this.period ? this.period : this.periods[0].id

            if(this.period == 'custom') {
                this.showAdvancedFilterVue = true
            }else{
                this.showAdvancedFilterVue = false;
            }

            this.filterByPeriod(this.period);

        },
        watch: {
            'dateFilter.start_at'(newVal, oldVal) {
                if(newVal != '' && this.dateFilter.end_at != ''){
                    this.filterByPeriodAndByDate(this.period, this.dateFilter);
                }
            },
            'dateFilter.end_at'(newVal, oldVal) {
                if(newVal != '' && this.dateFilter.start_at != ''){
                    this.filterByPeriodAndByDate(this.period, this.dateFilter);
                }
            }
        },
        methods: {
            filterByPeriod: function(period)
            {

                if(period == 'custom') {
                    this.showAdvancedFilterVue = true
                }else{
                    this.showAdvancedFilterVue = false;
                }

                if(period != 'custom') {

                    this.loaded = false;
                    this.period = period

                    ProtractorService.getStats( this.period ).then((response) => {
                        this.stats = response.data

                        this.loaded = true;
                    }).catch((response) => {
                        console.log("error", response);
                        this.loaded = true;
                    })

                }
            },
            filterByPeriodAndByDate: function(period, dateFilter)
            {
                this.loaded = false;

                this.period = period
                this.date = JSON.stringify(dateFilter);

                ProtractorService.getStats( this.period, this.date ).then((response) => {
                    this.stats = response.data

                    this.loaded = true;
                }).catch((response) => {
                    console.log("error", response);
                    this.loaded = true;
                })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/serevita/protractor/CommissionStatsWidget.vue